import { Injectable } from "@angular/core";
import { GetConfigUseCase } from "../../../core/config/get-config.use-case";

@Injectable()
export class AvatarService {
    private _avatarsList: string[] = [];

    constructor(private getConfigUseCase: GetConfigUseCase) {
    }

    async getAvatarsList(): Promise<string[]> {
        if (!this._avatarsList.length) {
            try {
                const config = await this.getConfigUseCase.execute();
                this._avatarsList = config ? config.avatars : [];
            } catch (e) {
                console.error(e);
            }
        }
        return Promise.resolve(this._avatarsList);
    }
}
